import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["sentInvoiceOrg", "billingContentCode", "applyDescription"]

  connect() {
    this.handleBillingContentCodeChange = this.handleBillingContentCodeChange.bind(this)
    this.billingContentCodeTarget.addEventListener('change', this.handleBillingContentCodeChange)

    $(this.sentInvoiceOrgTarget).selectize({
      plugins: ["remove_button"],
      respect_word_boundaries: false,
      onChange: function(value) {
        if (!value.length) return;

        const sent_invoice_org_change_url = `/financial_analysis/other_billing_and_inquiries/sent_invoice_org_change?sent_invoice_org_code=${encodeURIComponent(value)}`
        $.ajax(sent_invoice_org_change_url, {
          dataType: 'script'
        });
      }
    });
  }

  disconnect() {
    this.billingContentCodeTarget.removeEventListener('change', this.handleBillingContentCodeChange)
  }

  handleBillingContentCodeChange(event) {
    if (event.target.value === "S00004") {
      this.applyDescriptionTarget.value = "设计咨询费"
      this.applyDescriptionTarget.readOnly = true
    } else {
      this.applyDescriptionTarget.value = ""
      this.applyDescriptionTarget.readOnly = false
    }
  }
}
